// extracted by mini-css-extract-plugin
export default {"splitPane":"styles_splitPane__cPIJe","splitPaneElement":"styles_splitPaneElement__abVpY","separator":"styles_separator__9iL2e","dragging":"styles_dragging__SrLte"};